if (window.onlineBankingACF) { 
 
    const accountOpeningApplication = window.onlineBankingACF.accountOpeningApplication ?? 'temenos'; 
     
    const temenosPublicBaseUrl = window.onlineBankingACF.temenosPublicBaseUrl ?? 'https://account-opening.bellco.org/workspaces-bellco/servlet/SmartForm.html?formCode=bellco-usdaomp&product='; 
    const mantlPublicBaseUrl = window.onlineBankingACF.mantlPublicBaseUrl; 
     
    const temenosMemberBaseUrl = window.onlineBankingACF.temenosMemberBaseUrl ?? 'https://myaccounts.bellco.org/BLAccountOpening'; 
    const mantlMemberBaseUrl = window.onlineBankingACF.mantlMemberBaseUrl; 
     
    const onlineBankingMaintenanceUrl = window.onlineBankingACF.onlineBankingMaintenanceUrl ?? '/account-opening-maintenance/'; 
    const enableOnlineBankingMaintenanceMode = window.onlineBankingACF.enableOnlineBankingMaintenanceMode ?? false; 
     
    // console.log('ACF Data:', window.onlineBankingACF); 
     
    var $useMantl = false; 
    var $useMaintenancePage = false; 
        
    if (accountOpeningApplication == 'mantl') { 
        $useMantl = true; 
    } 
    if (accountOpeningApplication == 'temenos') { 
        $useMantl = false; 
    } 
    if(enableOnlineBankingMaintenanceMode == true) { 
        $useMaintenancePage = true; 
    } 
     
    var $urlMantlPublicBase   = mantlPublicBaseUrl; 
    var $urlTemenosPublicBase = temenosPublicBaseUrl; 
     
    // Variable member URLs (Bellco.org to Alkami to MANTL/Temenos): 
    var $urlMantlMemberBase   = mantlMemberBaseUrl; 
    var $urlTemenosMemberBase = temenosMemberBaseUrl; 
     
    // SCRIPT URLS 
    if ($useMantl) { 
        var $urlPublicApply = $urlMantlPublicBase; 
        var $urlMemberApply = $urlMantlMemberBase; 
    } else { 
        var $urlPublicApply = $urlTemenosPublicBase; 
        var $urlMemberApply = $urlTemenosMemberBase; 
    } 
     
    var $urlMaintenancePage = onlineBankingMaintenanceUrl; 
     
    // Temenos minor code to MANTL key 
    var $accountMinor_to_accountKey = { 
        "MEMB": "membershipAccount", 
        "SAVE": "savings", 
        "MMKT": "memberMoneyMarket", 
        "PMMK": "premierMoneyMarket", 
        "HYCK": "boostInterestChecking", 
        "FREE": "freeChecking", 
        "PLCK": "platinumChecking", 
        "CD03": "3MonthCd", 
        "PC06": "6MonthCd", 
        "CD07": "7MonthPromoCd", 
        "CD10": "10MonthPromoCd", 
        "PC12": "12MonthCd", 
        "PC13": "13MonthPromoCd", 
        "CD17": "17MonthPromoCd", 
        "PC21": "21MonthPromoCd", 
        "CD24": "24MonthCd", 
        "CD36": "36MonthCd", 
        "PC60": "60MonthCd", 
        "PJ06": "jumbo6MonthCd", 
        "PJ12": "jumbo12MonthCd", 
        "SM18": "smartMove18MonthCd", 
        "SM24": "smartMove24MonthCd", 
        "SM30": "smartMove30MonthCd", 
        "SM36": "smartMove36MonthCd" 
    }; 
     
} 
/*** OPEN AN ACCOUNT MODAL ***/ 
 
// Add the modal to the page 
document.body.insertAdjacentHTML('beforeend',` 
    <div id="openAnAccount-modal" class="modal-box" role="dialog" aria-labelledby="oaa-title" aria-describedby="oaa-default">
        <div class="modal-overlay" data-js="overlay"></div>
        <div class="modal-content"> 
            <h2 class="oaa-title h1">Open an Account</h2> 
            <button class="btn is-blue close modal-close exit-close first" aria-label="Close" data-action="close" id="sb-close"><span class="closer"></span>
            </button>
            <div class="oaa-default"> 
            <p>To get you through the application process as quickly as possible, let us know if you are already a member.</p> 
            <p class="last"> 
                <a class="btn oaa-btn-member" href="#" target="_blank" aria-label="Yes, I'm a member">Yes, I'm a member</a> 
                <a class="btn is-blue oaa-btn-new" href="#" target="_blank" aria-label="No, I'm not a member">No, I'm not a member</a> 
            </p> 
            </div> 
            <div class="oaa-membership"> 
            <p>Would you also like to open a <strong>Boost Interest Checking</strong> account with your membership application?</p> 
            <p> 
                <a class="btn oaa-btn-membership-only" href="#" target="_blank" aria-label="No, just membership" style="min-width: 220px">No, just membership</a> 
                <a class="btn is-blue oaa-btn-membership-boost" href="#" target="_blank" aria-label="Yes, include Boost Checking" style="min-width: 220px">Yes, include Boost Checking</a> 
            </p> 
            <p class="last" style="font-size: .725em; line-height: 1.5em"> 
                <strong>Boost Interest Checking</strong> is a free account that pays you a higher rate of interest than most accounts for doing many of the things you already do in a checking account, such as using your debit card and having a direct deposit. Plus there are no maintenance fees or minimum balance requirements! Bellco is insured by NCUA. 
            </p> 
            </div> 
        </div> 
    </div> 
`); 

jQuery(document).ready(function($) {

    var $header = $('header'); 
    var $modal = $('#openAnAccount-modal'); 
    var $modalContent = $('#openAnAccount-modal > .modal-content > div'); 
    var $modalClose = $('#openAnAccount-modal .close'); 
    var $elementToRefocus = null; 
    var $accountMinors = new Array(); 

    function OpenAnAccountModal_Open($startScreenClass) { 
        $('body').addClass('modal-open');
        $header.css('z-index', '-9999'); 
        $modal.fadeIn(); 
        $modalContent.hide(); 
        $($startScreenClass).show(); 
        $($startScreenClass + ' a:first-child').focus(); 
    } 

    function OpenAnAccountModal_Close() { 
        $('body').removeClass('modal-open');
        $header.css('z-index', '30'); 
        $modal.fadeOut(); 
        if ($elementToRefocus && $elementToRefocus.length) { 
            $elementToRefocus.focus(); 
        } 
    } 

    function OpenAnAccount_Switch(classOut, classIn) { 
        var $classOut = $(classOut); 
        var $classIn = $(classIn); 
        $classOut.toggle('slide', { direction: 'left' }, 'normal', function () { 
            $classIn.toggle('slide', { direction: 'right' }, 'normal', function () { 
                $(this).find('a:first').focus(); 
            }); 
        }); 
    } 

    window.OpenAnAccount = function($accountMinor, $accountName, e) { 
        if (e && typeof e.preventDefault === 'function') { 
            e.preventDefault(); 
            e.stopPropagation(); 
        } 
        if ($accountMinor == "MEMB" || $accountMinor == "membershipAccount") { 
            $('.oaa-title').html('Become a Bellco Member'); 
            if ($useMaintenancePage) { 
                $('.oaa-btn-membership-boost').attr('href', $urlMaintenancePage); 
                $('.oaa-btn-membership-only').attr('href', $urlMaintenancePage); 
            } else { 
                if ($useMantl) { 
                    $('.oaa-btn-membership-boost').attr('href', $urlPublicApply + "boostInterestChecking"); 
                    $('.oaa-btn-membership-only').attr('href', $urlPublicApply + "membershipAccount"); 
                } else { 
                    $('.oaa-btn-membership-boost').attr('href', $urlPublicApply + "HYCK"); 
                    $('.oaa-btn-membership-only').attr('href', $urlPublicApply + "MEMB"); 
                } 
            } 
            OpenAnAccountModal_Open('.oaa-membership'); 
        } else { 
            $('.oaa-title').html("Open a " + $accountName + " account"); 
            if ($useMaintenancePage) { 
                $('.oaa-btn-member').attr('href', $urlMaintenancePage); 
                $('.oaa-btn-new').attr('href', $urlMaintenancePage); 
            } else { 
                $('.oaa-btn-member').attr('href', $urlMemberApply); 
                if ($useMantl) { 
                    const $accountKey = ($accountMinor_to_accountKey.hasOwnProperty($accountMinor)) ? $accountMinor_to_accountKey[$accountMinor] : $accountMinor; 
                    $('.oaa-btn-new').attr('href', $urlPublicApply + $accountKey); 
                } else { 
                    $('.oaa-btn-new').attr('href', $urlPublicApply + $accountMinor); 
                } 
            } 
            OpenAnAccountModal_Open('.oaa-default'); 
        } 
    };
    // Close Trigger Click Handlers
    $modalClose.on('click', function (e) { 
        e.preventDefault();
        OpenAnAccountModal_Close(); 
        return false; 
    }); 

    $modal.on('click', '[data-js="overlay"]', function(e) { 
        e.preventDefault(); 
        e.stopPropagation(); 
        OpenAnAccountModal_Close(); 
    }); 

    // Keyboard Accessibility Management
    $(document).on('click', '.c-btn', function () { 
        $elementToRefocus = $(this); 
    }); 

    $(document).on('keydown', function(e) { 
        if ($modal.is(':visible') && (e.key === 'Escape' || e.keyCode === 27)) { 
            e.preventDefault(); 
            e.stopPropagation(); 
            OpenAnAccountModal_Close(); 
        } 
    });

    $modal.on('keydown', function (e) { 
        let tabPressed = e.key === 'Tab' || e.keyCode === 9; 
        let shiftPressed = e.shiftKey; 
        var $buttonLast = $modalContent.find('a:last'); 
        var $buttonFirst = $modalContent.find('a:first'); 
        var $buttonClose = $modalClose; 

        if (!tabPressed) return;

        if ($buttonLast.is(':focus')) { 
            if (!shiftPressed) { 
                $buttonClose.focus(); 
                e.preventDefault();
            } 
        } else if ($buttonFirst.is(':focus')) { 
            if (shiftPressed) { 
                $buttonClose.focus(); 
                e.preventDefault();
            } 
        } else if ($buttonClose.is(':focus')) { 
            if (shiftPressed) { 
                $buttonLast.focus(); 
            } else { 
                $buttonFirst.focus(); 
            } 
            e.preventDefault();
        } 
    }); 
});
/*** END OPEN AN ACCOUNT MODAL ***/
